import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Device } from '@era/locations-sdk';

@Component({
  selector: 'era-device-os-update-reset-ui',
  templateUrl: './device-os-update-reset.component.html',
  styleUrls: ['./device-os-update-reset.component.scss'],
})
export class DeviceOsUpdateResetComponent {
  @Input() public device: Device;
  @Output() public readonly resetClicked = new EventEmitter<Device>();

  public onReset() {
    this.resetClicked.emit(this.device);
  }
}
